module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_ie8-dom-define.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_ie8-dom-define.js
// module chunks = 168707334958949